import './index.css'

import React, { ReactElement, ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'

import ThemeContextProvider from '../context/ThemeContextProvider'
import { AuthenticatedComponent } from './Authenticated'
import AuthenticationPanel from './authenticationPanel'

export interface LayoutProps {
  children?: ReactNode
}

export default function Layout(props: LayoutProps): ReactElement {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>{t('common.app.title')}</title>
      </Helmet>

      <AuthenticatedTemplate>
        <ThemeContextProvider>
          <AuthenticatedComponent>{props.children}</AuthenticatedComponent>
        </ThemeContextProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AuthenticationPanel />
      </UnauthenticatedTemplate>
    </>
  )
}
